import { NotificationSettingsScreen } from "~/settings/notification-settings-screen";

// /settings — per-user device settings (V2-E4.1). Available to every
// authenticated user; currently hosts the notification permission + subscribe
// flow. Rendered inside <AppShell> like the rest of the protected routes.
export default function SettingsRoute(): JSX.Element {
  return <NotificationSettingsScreen />;
}
